class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', (event) => {
      this.close(true, event.currentTarget);
    });

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    /* Scrim only — never treat the field/results as an outside click. */
    if (event.target.closest('.search-modal__content')) return;
    if (event.target.classList.contains('modal-overlay') || !this.contains(event.target)) {
      this.close(false);
    }
  }

  open(event, options) {
    const keepPage = !!(options && options.keepPage);
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    if (!keepPage) document.body.addEventListener('click', this.onBodyClickEvent);

    this.scrollY = window.scrollY || document.documentElement.scrollTop || 0;

    const header = document.querySelector('.section-header');
    const rect = header ? header.getBoundingClientRect() : null;
    const top = rect ? Math.max(0, Math.round(rect.top)) : 0;
    let space = 0;
    if (header && rect) {
      const marginBottom = parseFloat(window.getComputedStyle(header).marginBottom) || 0;
      space = Math.round(rect.height + marginBottom);
    }

    /*
      Pin at the header's current on-screen top, and reserve its in-flow height
      so switching sticky→fixed does not collapse the page (the jump).
      Class + vars must land before body lock / details open.
    */
    document.documentElement.style.setProperty('--search-header-top', `${top}px`);
    document.documentElement.style.setProperty('--search-header-space', `${space}px`);
    document.documentElement.classList.add('search-open');
    event.target.closest('details').setAttribute('open', true);
    if (!keepPage) {
      document.body.classList.add('overflow-hidden');
      if (!window.matchMedia('(max-width: 989px)').matches) {
        document.documentElement.style.setProperty('--search-scroll-lock-y', `-${this.scrollY}px`);
        document.body.classList.add('search-scroll-locked');
      }

      const focusContainer = this.detailsContainer.querySelector('[tabindex="-1"]');
      const searchInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
      /* preventScroll: plain focus() makes mobile Safari scroll the field into view → jump. */
      trapFocus(focusContainer, focusContainer);
      if (searchInput) searchInput.focus({ preventScroll: true });
    }
  }

  close(focusToggle = true, source) {
    const exitUrl = document.documentElement.dataset.acSearchExit;
    if (exitUrl) {
      const button =
        (source && source.classList && source.classList.contains('search-modal__close-button') && source) ||
        this.querySelector('.search-modal__close-button');
      if (button) {
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
      }
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          window.location.assign(exitUrl);
        });
      });
      return;
    }

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden', 'search-scroll-locked');
    document.documentElement.classList.remove('search-open');
    document.documentElement.style.removeProperty('--search-scroll-lock-y');
    document.documentElement.style.removeProperty('--search-header-top');
    document.documentElement.style.removeProperty('--search-header-space');

    const sticky = document.querySelector('sticky-header');
    if (sticky && typeof sticky.setHeaderHeight === 'function') sticky.setHeaderHeight();

    if (typeof this.scrollY === 'number') {
      window.scrollTo(0, this.scrollY);
      this.scrollY = null;
    }
  }
}

customElements.define('details-modal', DetailsModal);

function acOpenSearchOnResults() {
  if (!document.documentElement.dataset.acSearchExit) return;
  const nodes = document.querySelectorAll('details-modal.header__search');
  let modal = null;
  for (let i = 0; i < nodes.length; i++) {
    if (window.getComputedStyle(nodes[i]).display !== 'none') {
      modal = nodes[i];
      break;
    }
  }
  if (!modal || typeof modal.open !== 'function' || modal.isOpen()) return;
  const summary = modal.querySelector('summary');
  if (!summary) return;
  modal.open({ target: summary }, { keepPage: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', acOpenSearchOnResults);
} else {
  acOpenSearchOnResults();
}
